import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { notification, modal, nestedModal } from 'redux/modules/app'
import { activityLogs as activityLogsApi } from 'redux/modules/api/combineDashboard'
import { badges as badgesApi } from 'redux/modules/api'
import { getLogs } from 'redux/modules/api/dashboard/activity'
import { fetchAward } from 'redux/modules/api/dashboard/awards'
import { schemaLog, schemaLogFiles } from 'models/logs'
import { get } from 'lodash'
import MODALS from '../../../../../constants/layout/modals'
import schemaLogs from '../../../../../models/logs/schemaLogs'


function decorator() {
  return ComposedComponent => {
    @connect(null, {
      ...activityLogsApi,
      ...badgesApi,
      notification,
      fetchAward,
      getLogs,
      modal,
      nestedModal,
      push
    })
    class apiActivityLogs extends Component {
      static propTypes = {
        modal: PropTypes.func.isRequired,
        nestedModal: PropTypes.func.isRequired,
        addLog: PropTypes.func.isRequired,
        addLogs: PropTypes.func.isRequired,
        editLog: PropTypes.func.isRequired,
        getLogs: PropTypes.func.isRequired,
        fetchAward: PropTypes.func.isRequired,
        deleteLog: PropTypes.func.isRequired,
        addLogFile: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        deleteLogFile: PropTypes.func.isRequired,
        getBadges: PropTypes.func.isRequired,
        getAwardBadges: PropTypes.func.isRequired,
        getBadgesProgress: PropTypes.func.isRequired
      }


      handleAddLog = (fields, id, { resetForm }) =>
        this.props.addLog(schemaLog(fields, id)).then(res => {

            this.props.addLogFile(res.body.id, schemaLogFiles(fields))

            const newBadges = get(res, 'body.newAwardBadges')

            const isBadgeAchieved = newBadges && newBadges.length > 0

            !isBadgeAchieved && this.handleSuccess(
              'Log has been added',
              'notifications.new_log_has_been_added',
              resetForm
            )
            this.handleRefreshBadges()
            isBadgeAchieved && this.props.modal(MODALS.NEW_BADGE_ACHIEVED, null, {
              data: newBadges[0]
            })
          })
          .catch(this.handleError)


      handleAddLogs = (fields, id, { resetForm }) =>
        this.props.addLogs(schemaLogs(fields, id)).then(async res => {

         const ids = get(res,'body.successfulIds') || []

         for (const id1 of ids) {
           await this.props.addLogFile(id1, schemaLogFiles(fields))
         }
            const newBadges = get(res, 'body.newAwardBadges')

            const isBadgeAchieved = newBadges && newBadges.length > 0

            !isBadgeAchieved && this.handleSuccess(
              'Logs has been added',
              'notifications.logs_has_been_added',
              resetForm
            )
            this.handleRefreshBadges()
            isBadgeAchieved && this.props.modal(MODALS.NEW_BADGE_ACHIEVED, null, {
              data: newBadges[0]
            })
          })
          .catch(this.handleError)

      handleEditLog = (fields, id, { resetForm }) => {
        this.props
          .editLog(fields.id, schemaLog(fields, null))
          .then(res =>{

            this.props.addLogFile(res.body.id, schemaLogFiles(fields))

            const newBadges = get(res, 'body.newAwardBadges')

            const isBadgeAchieved = newBadges && newBadges.length > 0

            !isBadgeAchieved && this.handleSuccess(
              'Log has been modified',
              'notifications.log_has_been_modified',
              resetForm
            )
            this.handleRefreshBadges()
            isBadgeAchieved && this.props.modal(MODALS.NEW_BADGE_ACHIEVED, null, {
              data: newBadges[0]
            })

          })
          .catch(this.handleError)


      }

      addLogFiles = (id, fileUrls) =>
        new Promise((resolve, reject) => {
          !fileUrls && resolve('success')
          this.addLogFilesSelfEx(id, fileUrls, { resolve, reject, count: 0 })
        })

      addLogFilesSelfEx = (id, fileUrls, { resolve, reject, count }) => {
        if (fileUrls[count]) {
          this.props
            .addLogFile({ activityLog: { id }, url: fileUrls[count].url })
            .then(() => {
              this.addLogFilesSelfEx(id, fileUrls, {
                resolve,
                reject,
                count: count + 1
              })
            })
            .catch(err => reject(err))
        } else {
          resolve('success')
        }
      }

      removeLogFiles = fileUrls =>
        new Promise((resolve, reject) => {
          !fileUrls && resolve('success')
          this.removeLogFilesSelfEx(fileUrls, { resolve, reject, count: 0 })
        })

      removeLogFilesSelfEx = (fileUrls, { resolve, reject, count }) => {
        if (fileUrls[count]) {
          this.props
            .deleteLogFile(fileUrls[count].id)
            .then(() => {
              this.removeLogFilesSelfEx(fileUrls, {
                resolve,
                reject,
                count: count + 1
              })
            })
            .catch(err => reject(err))
        } else {
          resolve('success')
        }
      }

      handleDeleteLog = id => {
        this.props
          .deleteLog(id)
          .then(() => {
            this.handleSuccess(
              'Log has been deleted',
              'notifications.log_has_been_deleted'
            )
              this.handleRefreshBadges()
          }).catch(this.handleError)
      }

      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        resetForm
      ) => {
        this.props.notification(text, { status: 'success', intlKey })
        this.props.modal(null, null)
        this.handleRefreshLogs()
        this.handleRefreshAward()
        resetForm && resetForm()
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleRefreshBadges = () => {
        const awardId = get(this.props, 'match.params.awardId')

        this.props.getAwardBadges(awardId)
        this.props.getBadgesProgress(awardId)

        this.handleRefreshLogs()
        this.handleRefreshAward()
      }

      handleRefreshLogs = () => {
        const { params } = this.props

        this.props.getLogs(params.activityId)
      }

      handleRefreshAward = () => {
        const { params } = this.props

        this.props.fetchAward(params.awardId, { fetchLogs: true })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onDeleteLog={this.handleDeleteLog}
            onEditLog={this.handleEditLog}
            onAddLog={this.handleAddLog}
            onAddLogs={this.handleAddLogs}
          />
        )
      }
    }
    return apiActivityLogs
  }
}

export default decorator
